import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';
import { v2ResourceDisplayName } from 'core/helpers';

import PageGroupsOrganizationDetailEditMembers from 'hcp/components/page/groups/organization/detail/members/edit';

<template>
  {{pageTitle (t "page-title.access-control.groups.edit-members")}}

  <BreadcrumbsItem
    @route="cloud.access-control.groups.detail"
    @text={{v2ResourceDisplayName @model.resourceName}}
  />

  <BreadcrumbsItem
    @text={{t
      "components.page.access-control.groups.detail.members.edit-members.breadcrumb"
    }}
  />

  <PageGroupsOrganizationDetailEditMembers
    @resourceName={{@model.resourceName}}
    @eligibleMembers={{@model.eligibleMembers}}
  />
</template>
